import React, { createContext } from 'react'

import noop from 'lib/function/noop'

export interface MapLayer {
  id: string
  title: string
  icon?: React.ReactNode
  isSelected: boolean
}

/** Other types will be added later */
export type MapLayerGroupId = 'itinerary'

export interface MapLayerGroup {
  id: MapLayerGroupId
  title: string
  selectAllLabel: string
  selectionStatus: 'all' | 'some' | 'none'
  layers: Array<MapLayer>
}

export interface MapLayersContextValue {
  layerGroups: Array<MapLayerGroup>
  toggleLayer: (group: MapLayerGroupId, id: string) => void
  toggleGroup: (group: MapLayerGroupId) => void
}

const MapLayersContext = createContext<MapLayersContextValue>({ layerGroups: [], toggleLayer: noop, toggleGroup: noop })

export default MapLayersContext
